import { Auth } from 'aws-amplify';
import {
    ENDEAVOR_AUTH,
    GRANT_TYPE,
    REACT_APP_ENDEAVOR_BASE_URL,
    REACT_APP_ENDEAVOR_REALM,
    REACT_APP_ENDEAVOR_X_API_KEY,
    SUBJECT_TOKEN,
    SUBJECT_TOKEN_TYPE,
}
    from '../constants/api-constants';
import api from '../endeavor-api';
import { getSessionStorageItem, setSessionStorageItem } from '../../../utils';

export const getGuestUserTokenAsync = async () => {
    try {
        const response = await api.post(`${REACT_APP_ENDEAVOR_BASE_URL}/api/v2/login/guest/checkin`, {}, {
            headers: {
                'x-api-key': REACT_APP_ENDEAVOR_X_API_KEY,
                Realm: REACT_APP_ENDEAVOR_REALM,
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        const responseData = response.data;
        if (responseData) {
            return {
                authorizationToken: responseData.authorisationToken,
                error: { isEmpty: true },
            };
        }
        return { error: { isEmpty: true }, authorizationToken: undefined };
    } catch (error) {
        return {
            error: {
                isEmpty: false,
                value: error,
            },
            authorizationToken: undefined,
        };
    }
};

export async function getTokenExchange(input) {
    const {
        xApiKey,
        realm
    } = input;
    try {
        const data = await Auth.currentSession();

        const { accessToken, idToken, refreshToken } = data;

        const subjectToken = JSON.stringify({
            idToken: idToken.jwtToken,
            accessToken: accessToken.jwtToken,
            refreshToken: refreshToken.token,
        });

        const params = new URLSearchParams();
        params.append(GRANT_TYPE, 'urn:ietf:params:oauth:grant-type:token-exchange');
        params.append(SUBJECT_TOKEN_TYPE, 'idAccessRefresh');
        params.append(SUBJECT_TOKEN, subjectToken);

        try {
            const responseData = await api
                .post(`${REACT_APP_ENDEAVOR_BASE_URL}/api/v2/openid/aws_cognito_randa_sso/exchange`, params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        Accept: '*/*',
                        'x-api-key': xApiKey,
                        Realm: realm,
                    },
                });
            return {
                authorizationToken: responseData.data.access_token,
                error: { isEmpty: true },
            };
        } catch (error) {
            return {
                error,
            };
        }
    } catch (error) {
        return {
            error,
        };
    }
}

export const fetchToken = async () => {
    let authToken;
    const responseTokenExchange = await getTokenExchange({
        realm: REACT_APP_ENDEAVOR_REALM,
        xApiKey: REACT_APP_ENDEAVOR_X_API_KEY
    });
    if (responseTokenExchange.authorizationToken) {
        authToken = responseTokenExchange.authorizationToken;
    } else {
        const responseGuestToken = await getGuestUserTokenAsync();
        authToken = responseGuestToken.authorizationToken;
    }
    return authToken;
};

export const getToken = async () => {
    const sessionStorageToken = getSessionStorageItem(ENDEAVOR_AUTH);
    if (sessionStorageToken) {
        return sessionStorageToken;
    }
    const authToken = await fetchToken();
    setSessionStorageItem(ENDEAVOR_AUTH, authToken);
    return authToken;
};
